import { Link } from 'react-router-dom';
import { ArticleContent } from '@/mocks/articles';

interface RelatedArticlesProps {
  articles: ArticleContent[];
}

export default function RelatedArticles({ articles }: RelatedArticlesProps) {
  if (articles.length === 0) return null;

  return (
    <div className="mt-12 pt-10 border-t border-background-200/40">
      <h3 className="text-lg font-heading font-bold text-foreground-100 mb-6 flex items-center gap-2">
        <i className="ri-links-line text-primary-400"></i>
        相关推荐
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {articles.map((article) => (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/40 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
          >
            <div className="relative h-40 overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                title={article.title}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 to-transparent"></div>
            </div>
            <div className="p-4">
              <h4 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors duration-200 line-clamp-2 leading-snug">
                {article.title}
              </h4>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                <span>{article.date}</span>
                <span>{(article.views / 1000).toFixed(1)}k 阅读</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}